// extracted by mini-css-extract-plugin
module.exports = {"appElement":"_3Hcp44gYEA50f_kTznIWys","icon":"_3_M-21lvtrKKTuZPPX_LJJ","selected":"QQb-kUOgclad-B_NHRL6L","appName":"eIRPTnlR67BhfdS3ah4WU"};